import styled from 'styled-components'

export const AnchorTagBtn = styled.a`
  background-color: ${props => props.theme.primary};
  color: ${props => props.theme.darkerGold};
  padding: 12px;
  border-radius: 12px;
  display: flex;
  flex: 1;
  font-weight: 800;
  font-size: 14px;
  align-items: center;
  justify-content: center;
  text-decoration: none;
`

export const ButtonWithArrow = styled.button`
  width: 100%;
  border: none;
  display: flex;
  cursor: pointer;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  background-color: ${props => props.theme.white};
  font-size: 12px;
  padding: 16px;
  border-radius: 10px;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.01), 0 6px 16px 0 rgba(0,0,0,0.06);
`
